import axios from 'axios';
import { setupAuthInterceptor } from './authInterceptor';
let apiInstance = null;
export function initApi(baseURL) {
    apiInstance = axios.create({
        baseURL,
        withCredentials: true, // THIS IS MANDATORY for session cookies to work
        // --- 新增以下兩行 ---
        // xsrfCookieName: 'XSRF-TOKEN',   // 這是後端 Set-Cookie 的名稱
        // xsrfHeaderName: 'X-XSRF-TOKEN', // 這是後端 Middleware 要檢查的 Header 名稱
        headers: {
            'Content-Type': 'application/json',
            // 新增這行：這是一個常見的防禦 CSRF 手段
            // 因為攻擊者（如 <img> 或 <form>）無法自定義請求頭
            'X-Requested-With': 'XMLHttpRequest'
        },
    });
    setupAuthInterceptor(apiInstance, baseURL);
    return apiInstance;
}
export function api() {
    if (!apiInstance)
        throw new Error('API not initialized');
    return apiInstance;
}
